import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-new-03",
  "use": "icon-new-03-usage",
  "viewBox": "0 0 12 13",
  "content": "<symbol viewBox=\"0 0 12 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-new-03\">\r\n<g id=\"icon-new-03_Frame\">\r\n<path id=\"icon-new-03_Vector\" d=\"M9 6.82116L4.50004 11.3169L3 9.81832L6.00003 6.82116L3 3.82405L4.50004 2.3255L9 6.82116Z\" fill=\"#92959C\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol